var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32733 4.41083C7.00189 4.73626 7.00189 5.2639 7.32733 5.58934L11.7381 10.0001L7.32733 14.4108C7.00189 14.7363 7.00189 15.2639 7.32733 15.5893C7.65277 15.9148 8.1804 15.9148 8.50584 15.5893L13.8005 10.2947C13.9632 10.132 13.9632 9.86817 13.8005 9.70545L8.50584 4.41083C8.1804 4.08539 7.65277 4.08539 7.32733 4.41083Z",
    fill: "#0061FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightBlue);
export default __webpack_public_path__ + "static/media/chevron-right-blue.66ab3767d2788620261e9d6e5a17c4b1.svg";
export { ForwardRef as ReactComponent };